/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type TaskType =
  | "BBD_CHECK"
  | "EOY_INVENTORY_CHECK"
  | "EOY_INVENTORY_RECOUNT_CHECK"
  | "FRESHNESS_CHECK"
  | "INVENTORY_DISCREPANCY_CHECK"
  | "STOCK_CHECK";

export type ValidateEoyCheckInput = {
  checkId: string | number;
  name: string;
  quantity: number;
  type: TaskType;
};

export type ValidateEoyCheckMutationVariables = Exact<{
  input: Types.ValidateEoyCheckInput;
}>;

export type ValidateEoyCheckMutation = { validateEoyCheck: { success: boolean } };

export const ValidateEoyCheckDocument = gql`
  mutation validateEoyCheck($input: ValidateEoyCheckInput!) {
    validateEoyCheck(input: $input) {
      success
    }
  }
`;
export type ValidateEoyCheckMutationFn = Apollo.MutationFunction<
  ValidateEoyCheckMutation,
  ValidateEoyCheckMutationVariables
>;

/**
 * __useValidateEoyCheckMutation__
 *
 * To run a mutation, you first call `useValidateEoyCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateEoyCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateEoyCheckMutation, { data, loading, error }] = useValidateEoyCheckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateEoyCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateEoyCheckMutation,
    ValidateEoyCheckMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ValidateEoyCheckMutation, ValidateEoyCheckMutationVariables>(
    ValidateEoyCheckDocument,
    options,
  );
}
export type ValidateEoyCheckMutationHookResult = ReturnType<typeof useValidateEoyCheckMutation>;
export type ValidateEoyCheckMutationResult = Apollo.MutationResult<ValidateEoyCheckMutation>;
export type ValidateEoyCheckMutationOptions = Apollo.BaseMutationOptions<
  ValidateEoyCheckMutation,
  ValidateEoyCheckMutationVariables
>;
